<template>
  <div class="my_split_line">
    <div :class="type == 'one_level' ? 'set_one_level' : 'set_two_level'">
      <span
        class="title"
        :style="{
          width: titleWidth + 'px'
        }"
      ></span>
      <div class="stylePart set_two_level">
        <div class="style_1 style_div" :class="{ active: rotate_value == 0 }" @click="rotate_value = 0">
          <div class="line">
            <span class="lineShow">|</span>
            <span class="activeIcon el-icon-check"></span>
          </div>
        </div>
        <div class="style_2 style_div" :class="{ active: rotate_value == 30 }" @click="rotate_value = 30">
          <div class="tiltLine">
            <span class="lineShow">|</span>
            <span class="activeIcon el-icon-check"></span>
          </div>
        </div>
      </div>
    </div>
    <my_color
      :titleWidth="title_width"
      :title="$t('view_back_top_edit_99')"
      class="minRight"
      type="two_level"
      :color.sync="color_value"
      :pattern.sync="patternValue"
      :linear_gradient.sync="linear_gradient"
    ></my_color>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_split_line',
  props: {
    titleWidth: {
      type: String,
      default: '40'
    },
    type: {
      // 组件的类型  one_level 一级组件 two_level 二级组件
      type: String,
      default: 'two_level'
    },
    colorValue: {
      type: String
    },
    pattern: {
      type: String
    },
    linearGradient: {},
    rotate: {
      type: Number
    }
  },
  data() {
    return {
      title_width: this.titleWidth,
      patternValue: this.pattern,
      linear_gradient: this.linearGradient,
      color_value: this.colorValue,
      rotate_value: this.rotate
    };
  },
  mounted() {},
  watch: {
    linear_gradient(val) {
      // 数据双向绑定
      this.$emit('update:linearGradient', val);
    },
    patternValue(val) {
      // 数据双向绑定
      console.log(val);
      this.$emit('update:pattern', val);
    },
    color_value(val) {
      // 数据双向绑定
      this.$emit('update:colorValue', val);
    },
    rotate_value(val) {
      // 数据双向绑定
      this.$emit('update:rotate', val);
    },
    rotate(val) {
      this.rotate_value = val;
    },
    linearGradient(val) {
      this.linear_gradient = val;
    },
    pattern(val) {
      this.patternValue = val;
    },
    colorValue(val) {
      // 数据双向绑定
      this.color_value = val;
    }
  }
};
</script>

<style scoped type="text/css" lang="scss">
.setOne {
  display: flex;
  justify-content: flex-start;
}
.my_split_line {
  .stylePart {
    .style_div {
      width: 52px;
      height: 27px;
      color: #333;
      border: 1px solid #eee;
      text-align: center;
      line-height: 27px;
      margin-right: 10px;
      position: relative;
      font-size: 14px;
      .activeIcon {
        display: none;
        width: 18px;
        height: 16px;
        color: #fff;
        position: absolute;
        bottom: 0;
        right: 0;
        background-color: #5874d8;
        line-height: 22px;
        font-size: 12px;
        padding: 0 3px;
        border-top-left-radius: 100%;
      }
    }
    .style_div.active {
      border: 1px solid #5874d8;
      .activeIcon{
        display: block;
      }
    }
    .style_2 .tiltLine .lineShow{
      display: block;
      transform: rotate(30deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_split_line/index.vue